module.exports = __webpack_public_path__ + "img/icono-doc.46f7b391.svg";